<template>
  <div name="pupiladd" class="-mx-3 -mt-4">

    <section v-if="errored" class="w-full text-center mt-2">
              <h3 class="font-bold text-xl text-action-red">There was an issue adding the pupil details. </h3>
              <p class="text-action-blue">Please try again shortly or contact us to resolve the issue.</p>
            </section>



    <section v-if="isComplete" class="w-full text-center mt-10">
              <h3 class="font-bold text-xl text-action-blue">Pupil details have been added. </h3>
              <p class="text-action-blue">The pupil details can be viewed or editied in the main pupil listing.</p>
              <button
                @click="isComplete = false"
                type="button"
                class="publish-button hover:bg-blue-300 mt-4"
              >
                Add another pupil
              </button>
            </section>


    <form v-else v-on:submit.prevent="submitPupil" id="pupilForm" ref="form">
      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600 ">Pupil Name</label>

          <input
            v-model="name"
            id="grid-title"
            type="text"
            placeholder="Enter pupil name"
            required
          />
          <p class="text-red-300 text-xs italic">Please fill out this field.</p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold text-gray-600">Gender</label>

          <div class="flex justify-start py-2">
            <button
              type="button"
              class="
                selection-button
                hover:bg-gray-400 hover:bg-opacity-50
                font-bold
                icon
                fa-male
                mr-3
              "
              v-bind:class="[
                'male' == gender
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="gender = 'male'"
            >
              Male
            </button>

            <button
              type="button"
              class="
                selection-button
                hover:bg-gray-400 hover:bg-opacity-50
                font-bold
                icon
                fa-female
              "
              v-bind:class="[
                'female' == gender
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="gender = 'female'"
            >
              Female
            </button>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
        <div class="mx-6">
          <label class="font-semibold pb-2 text-gray-600">Year Group</label>
          <div class="py-4">
          <dropdown
            :options="yearDropdown"
            :selected="yearSelected"
            id="grid-year"
            v-on:updateOption="selectYearValue"
            mode="form"
            class="w-1/2 bg-gray-100 my-2"
          ></dropdown>
        </div>

          <p class="text-red-300 text-xs italic pt-2">
            Please fill out this field.
          </p>
      
        </div>
      </div>

      <div class="grid grid-cols-2 space-y-1 py-4 border-b border-gray-200">
        <div class="ml-6 pr-4 border-r">
          <label class="font-semibold text-gray-600">SEN</label>
          <input
            v-model="sen"
            id="grid-sen"
            type="text"
            placeholder="Enter SEN details..."
          />
     
        </div>

        <div class="mx-6">
          <label class="font-semibold text-gray-600">Ethnicity</label>
          <input
            v-model="ethnicity"
            id="grid-ethnicity"
            type="text"
            placeholder="Enter Ethnicity details..."
          />
        </div>
      </div>

      <div class="grid grid-cols-2 space-y-1 py-4 border-b border-gray-200">
        <div class="ml-6 pr-4 border-r">
          <label class="font-semibold mb-2 pb-2 text-gray-600"> Class / Group</label>
          <div class="mt-2 -ml-1">
        
            <ClassDropdown @classValueChanged="classSelect"></ClassDropdown>

              </div>
          </div>

            <div class="pt-6 mx-4">
              <input
                v-model="classNew"
                class="mb-2"
                id="grid-sen"
                type="text"
                placeholder="Or enter new class..."
              />
            </div>
 

          <p class="text-red-300 ml-6 text-xs italic">
            Please fill out this field.
          </p>
        
      </div>


      <div class="grid grid-cols-2 space-y-1 py-4 border-b border-gray-200">
        <div class="ml-6 pr-4 border-r">
          <label class="font-semibold text-gray-600">Pupil Premium </label>
          <div class="flex py-4">
            <button
              type="button"
              class="
                hover:bg-gray-400 hover:bg-opacity-50
                selection-button
                mr-3
              "
              v-bind:class="[
                hasPupilPremium
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="hasPupilPremium = true"
            >
              <i
                class="fas"
                v-bind:class="
                  hasPupilPremium ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              Yes - On
            </button>

            <button
              type="button"
              class="hover:bg-gray-400 hover:bg-opacity-50 selection-button"
              v-bind:class="[
                !hasPupilPremium
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="hasPupilPremium = false"
            >
              <i
                class="fas"
                v-bind:class="
                  !hasPupilPremium ? 'fa-check-circle' : 'fa-dot-circle'
                "
              ></i>
              No - Off
            </button>
          </div>
        </div>
        <div class="mx-6">
          <label class="font-semibold text-gray-600">English as Second Language </label>
          <div class="flex py-4">
            <button
              type="button"
              class="
                mr-3
                hover:bg-gray-400 hover:bg-opacity-50
                selection-button
              "
              v-bind:class="[
                hasEAL
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="hasEAL = true"
            >
              <i
                class="fas"
                v-bind:class="hasEAL ? 'fa-check-circle' : 'fa-dot-circle'"
              ></i>
              Yes - On
            </button>

            <button
              type="button"
              class="selection-button hover:bg-gray-400 hover:bg-opacity-50"
              v-bind:class="[
                !hasEAL
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="hasEAL = false"
            >
              <i
                class="fas"
                v-bind:class="!hasEAL ? 'fa-check-circle' : 'fa-dot-circle'"
              ></i>
              No - Off
            </button>
          </div>
        </div>

      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200 mr-6">
        <div class="mx-6">
          
          <div class="font-semibold flex justify-between w-ful pb-4 text-gray-600">Tags
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500  mr-2  tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                      <div
                        class="mr-2 tag-example"
                        style="background-color: #ef6c00;"
                        @click="addTags('bronze')"
                      >
                        #bronze
                      </div>

                      <div
                        class="mr-2 tag-example w-12"
                         style="background-color: #616161;"
                        @click="addTags('silver')"
                      >
                        #silver
                      </div>

                      <div
                        class="mr-2 tag-example w-10"
                                  style="background-color: #fdd835;"
                        @click="addTags('gold')"
                      >
                        #gold
                      </div>

                      <div
                        class="bg-red-500 mr-2 tag-example w-10"
                        @click="addTags('20percent')"
                      >
                        #20%
                      </div>
                    </div>
                    
                  </div>
                  <input
                v-model="tags"
                class="p-1"
                type="text"
                placeholder="Enter tags..."
              />
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200 mr-6">
        <div class="mx-6">
          
          <div class="font-semibold flex justify-between w-ful pb-4 text-gray-600">Additional Notes </div>
          <textarea
            v-model="notes"
            type="text"
            placeholder="Enter notes..."
                  class="p-1"
          ></textarea>
        </div>
      </div>

      <div class="h-10 text-left w-11/12 mt-6 ml-6 mb-20">
        <button
          @click="submitForm()"
          type="button"
          class="publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"

        >
          Publish Changes
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";

const dropdown = () => import("@/components/Dropdown.vue");
const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");

export default {
  name: "register_edit",
  props: {
    years: Array,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    // ...mapGetters({ currentUser: 'currentUser' }),
    isDisabled() {
      if (this.selectedClass.id > 0 && this.name.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    yearDropdown() {
      let results = [{ id: 0, name: "Select a year group" }].concat(this.years);
      if (this.yearSelected.id === undefined) {
        this.yearSelected = results[0];
      }
      return results;
    },
    componentLoaded() {
      return this.users.length > 0;
    },
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      isComplete: false,

      hasPupilPremium: false,
      hasEAL: false,
      selectedClass: {},
      selectedOrg: {},
      yearSelected: {},
      types: [],
      sen: "",
      ethnicity: "",
      name: "",
      gender: "male",
      classNew: "",
      notes: "",
      tags: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.submitPupil();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    alertDisplay() {
      this.$swal({
        title: "Please complete all fields",
        text: "You must enter a title and set a class to complete the form.",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result === true) {
         // this.processPupil();
        }
      });
    },
    submitPupil() {
      console.log(this.yearSelected.id)
      this.errored = false
      if (this.name == "" ||
        (this.selectedClass.id === 0 && this.classNew.length === 0) ||
          (this.yearSelected.id === undefined || this.yearSelected.id === 0)){
        this.alertDisplay();
      } else {
        this.processPupil();
      }
    },
    processPupil() {
      // values
      var pupil = {}
      pupil.name = this.name;
      pupil.gender = this.gender;
      pupil.year_id = this.yearSelected.id;
      pupil.notes = this.notes

      if (this.selectedClass.id === 0) {
        pupil.inclass = this.classNew;
      } else {
        pupil.inclass = this.selectedClass.name;
      }

      let eal = this.hasEAL === true ? 1 : 0;
      pupil.english_second = eal;

      let premium = this.hasPupilPremium === true ? 1 : 0;
      pupil.premium_pupil = premium;

      pupil.ethnicity = this.ethnicity;
      pupil.sen_status = this.sen;
      pupil.tags = this.tags

        SchoolService.create("pupils", pupil)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err);
          });
      
    },
    addTags(value) {
      let seperator = this.tags.length > 0 ? " #" : "#"
      this.tags = this.tags + seperator + value
    },
    selectYearValue(yeargroup) {
      this.yearSelected = yeargroup;
    },
    completion() {
      this.isComplete = true
      this.$emit('pupil-added')
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.isComplete = false
      this.errored = true
      console.log("Pupil update error " + error);
    },
    classSelect(value) {
      this.selectedClass = value;
    },
  },
  components: {
    dropdown,
    ClassDropdown
  },
};
</script>

<style scoped>



input:focus,
textarea:focus,
select:focus {
  outline: none;
}

input[type="text"] {
  @apply m-0 px-0 py-2 border-none h-auto rounded-none;
}

input[type="text"]:focus {
  border-bottom: 1px solid #a0aec0;
}

::-webkit-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

::-moz-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}

:-ms-input-placeholder {
  color: #a0aec0 !important;
  opacity: 0.8;
}
</style>